import _map       from 'lodash/map'
import _includes  from 'lodash/includes'

class RegistrationHelper {
  constructor (Localization, ValidationRules, VehicleService, UserService) {
    'ngInject'
    this.appConfig = Localization.getLocalizedAppConfig()
    this.ValidationRules = ValidationRules
    this.VehicleService = VehicleService
    this.UserService = UserService
  }

  /**
   * Verify that the model is into the list.
   * @param {string} model - model name
   * @param {object} models - a list of models
   * @return {boolean} model status in the configuration
   */
  checkModel (model, models) {
    if (!models) return false
    return model ? _includes(_map(models, 'id'), model) : false
  }

  /**
   * Verify that the VIN exists
   *
   * @param {string} vin - VIN
   * @return {Promise} vin online status
   */
  checkVin (vin) {
    if (vin && vin.length === 17) {
      return this.VehicleService.checkVin(vin)
      .then(() => Promise.resolve(true), () => Promise.resolve(false))
    }
    return Promise.resolve(false)
  }

  /**
   * Verify that the MUID is well formated
   *
   * @param {string} muid - muid
   * @return {boolean} true if the MUID matches the pattern, false otherwise
   */
  checkMuid (muid) {
    const muidRegex = new RegExp(this.ValidationRules.muid.pattern)
    return (muid && muidRegex.test(muid))
  }

  /**
   * Verify if the civility is into the list
   *
   * @param {string} civility - civility
   * @return {boolean} true if the civility is in the list, false otherwise
   */
  checkCivility (civility) {
    return civility ? _includes(_map(this.ValidationRules.civility, 'id'), civility) : false
  }

  /**
   * Verify that the email is well formated
   *
   * @param {string} email - email
   * @return {boolean} true if the email matches the pattern, false otherwise
   */
  checkEmail (email) {
    const emailRegex = new RegExp(this.ValidationRules.email.pattern)
    return (email && emailRegex.test(email))
  }

  /**
   * Verify that a property contains less than a given number of characters
   *
   * @param {string} prop - property to test
   * @param {number} length - max length
   * @return {boolean} true if the property contains at most the number of characters wanted, false otherwise
   */
  checkMaxLength (prop, length) {
    return (prop && prop.length <= length)
  }

  /**
   * Verify that the phone number is well formated
   *
   * @param {string} phoneNumber - phone number
   * @return {boolean} true if the phone number matches the pattern, false otherwise
   */
  checkPhoneNumber (phoneNumber) {
    const phoneNumberRegex = new RegExp(this.ValidationRules.phoneNumber.pattern)
    return (phoneNumber && phoneNumberRegex.test(phoneNumber))
  }

  /**
   * Verify password
   *
   * @param {string} password - password
   * @return {Promise} password complexity
   */
  checkPassword (password) {
    if (password && password.length >= 8 && password.length <= 32) {
      return this.UserService.checkPassword(password)
        .then((res) => Promise.resolve(true), () => Promise.resolve(false))
    }
    return Promise.resolve(false)
  }
}

export default RegistrationHelper



// WEBPACK FOOTER //
// ./src/app/pages/registration/helper/registration.helper.js